import React from 'react';
import type { Theme } from '../../app/theme';
import { useThemeStore } from '../../app/theme';
import { Button } from '../ui/Button';
import { Monitor, Moon, Sun } from 'lucide-react';

export const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useThemeStore();

  const cycleTheme = () => {
    const order: Theme[] = ['system', 'light', 'dark'];
    const currentIndex = order.indexOf(theme);
    const next = order[(currentIndex + 1) % order.length] ?? 'system';
    setTheme(next);
  };

  const labels: Record<Theme, string> = {
    system: 'System',
    light: 'Light',
    dark: 'Dark',
  };
  const icons: Record<Theme, React.ReactNode> = {
    system: <Monitor aria-hidden="true" />,
    light: <Sun aria-hidden="true" />,
    dark: <Moon aria-hidden="true" />,
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={cycleTheme}
      title={`Theme: ${theme}. Click to change.`}
      aria-label={`Theme: ${theme}`}
    >
      {icons[theme]}
      <span className="sedlex-theme-label">{labels[theme]}</span>
    </Button>
  );
};
